var map = {
	"./April2025": [
		92234,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		92234
	],
	"./April2025/": [
		92234,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		92234
	],
	"./April2025/index": [
		92234,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		92234
	],
	"./April2025/index.tsx": [
		92234,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		92234
	],
	"./AviatorUp": [
		33537,
		9,
		74705,
		12305,
		36320,
		77598,
		18819,
		33537
	],
	"./AviatorUp/": [
		33537,
		9,
		74705,
		12305,
		36320,
		77598,
		18819,
		33537
	],
	"./AviatorUp/animation/aviatorFirstClick": [
		18819,
		3,
		18819
	],
	"./AviatorUp/animation/aviatorFirstClick.json": [
		18819,
		3,
		18819
	],
	"./AviatorUp/animation/aviatorSecondClick": [
		77598,
		3,
		77598
	],
	"./AviatorUp/animation/aviatorSecondClick.json": [
		77598,
		3,
		77598
	],
	"./AviatorUp/index": [
		33537,
		9,
		74705,
		12305,
		36320,
		77598,
		18819,
		33537
	],
	"./AviatorUp/index.tsx": [
		33537,
		9,
		74705,
		12305,
		36320,
		77598,
		18819,
		33537
	],
	"./BanksBenefitsMay2025": [
		22259,
		9,
		44539,
		36320,
		83579,
		97567,
		22259
	],
	"./BanksBenefitsMay2025/": [
		22259,
		9,
		44539,
		36320,
		83579,
		97567,
		22259
	],
	"./BanksBenefitsMay2025/helpers": [
		59614,
		9,
		59614
	],
	"./BanksBenefitsMay2025/helpers.ts": [
		59614,
		9,
		59614
	],
	"./BanksBenefitsMay2025/index": [
		22259,
		9,
		44539,
		36320,
		83579,
		97567,
		22259
	],
	"./BanksBenefitsMay2025/index.tsx": [
		22259,
		9,
		44539,
		36320,
		83579,
		97567,
		22259
	],
	"./BigBass": [
		4497,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		4497
	],
	"./BigBass/": [
		4497,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		4497
	],
	"./BigBass/index": [
		4497,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		4497
	],
	"./BigBass/index.tsx": [
		4497,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		4497
	],
	"./BonusClaim": [
		28629,
		9,
		74332,
		36320,
		35550,
		70290,
		28629
	],
	"./BonusClaim/": [
		28629,
		9,
		74332,
		36320,
		35550,
		70290,
		28629
	],
	"./BonusClaim/index": [
		28629,
		9,
		74332,
		36320,
		35550,
		70290,
		28629
	],
	"./BonusClaim/index.tsx": [
		28629,
		9,
		74332,
		36320,
		35550,
		70290,
		28629
	],
	"./BuffaloWheel": [
		47883,
		9,
		74332,
		36320,
		35550,
		70290,
		47883
	],
	"./BuffaloWheel/": [
		47883,
		9,
		74332,
		36320,
		35550,
		70290,
		47883
	],
	"./BuffaloWheel/index": [
		47883,
		9,
		74332,
		36320,
		35550,
		70290,
		47883
	],
	"./BuffaloWheel/index.tsx": [
		47883,
		9,
		74332,
		36320,
		35550,
		70290,
		47883
	],
	"./CardsBenefitsJune2025": [
		94231,
		9,
		44539,
		36320,
		83579,
		97567,
		94231
	],
	"./CardsBenefitsJune2025/": [
		94231,
		9,
		44539,
		36320,
		83579,
		97567,
		94231
	],
	"./CardsBenefitsJune2025/helpers": [
		35722,
		9,
		35722
	],
	"./CardsBenefitsJune2025/helpers.ts": [
		35722,
		9,
		35722
	],
	"./CardsBenefitsJune2025/index": [
		94231,
		9,
		44539,
		36320,
		83579,
		97567,
		94231
	],
	"./CardsBenefitsJune2025/index.tsx": [
		94231,
		9,
		44539,
		36320,
		83579,
		97567,
		94231
	],
	"./Carways2025": [
		5185,
		9,
		36320,
		5185
	],
	"./Carways2025/": [
		5185,
		9,
		36320,
		5185
	],
	"./Carways2025/index": [
		5185,
		9,
		36320,
		5185
	],
	"./Carways2025/index.tsx": [
		5185,
		9,
		36320,
		5185
	],
	"./Circle": [
		42174,
		9,
		36320,
		26335,
		42174
	],
	"./Circle/": [
		42174,
		9,
		36320,
		26335,
		42174
	],
	"./Circle/index": [
		42174,
		9,
		36320,
		26335,
		42174
	],
	"./Circle/index.tsx": [
		42174,
		9,
		36320,
		26335,
		42174
	],
	"./CircusNovember": [
		39210,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		39210
	],
	"./CircusNovember/": [
		39210,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		39210
	],
	"./CircusNovember/helpers": [
		3954,
		9,
		3954
	],
	"./CircusNovember/helpers.ts": [
		3954,
		9,
		3954
	],
	"./CircusNovember/index": [
		39210,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		39210
	],
	"./CircusNovember/index.tsx": [
		39210,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		39210
	],
	"./CrownBanner": [
		98280,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		98280
	],
	"./CrownBanner/": [
		98280,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		98280
	],
	"./CrownBanner/index": [
		98280,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		98280
	],
	"./CrownBanner/index.tsx": [
		98280,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		98280
	],
	"./CrownMarch25": [
		72174,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		72174
	],
	"./CrownMarch25/": [
		72174,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		72174
	],
	"./CrownMarch25/helpers": [
		77377,
		9,
		5761
	],
	"./CrownMarch25/helpers.ts": [
		77377,
		9,
		5761
	],
	"./CrownMarch25/index": [
		72174,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		72174
	],
	"./CrownMarch25/index.tsx": [
		72174,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		72174
	],
	"./CrownReg": [
		70620,
		9,
		74332,
		36320,
		35550,
		70290,
		70620
	],
	"./CrownReg/": [
		70620,
		9,
		74332,
		36320,
		35550,
		70290,
		70620
	],
	"./CrownReg/index": [
		70620,
		9,
		74332,
		36320,
		35550,
		70290,
		70620
	],
	"./CrownReg/index.tsx": [
		70620,
		9,
		74332,
		36320,
		35550,
		70290,
		70620
	],
	"./CrownWheel": [
		57600,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		57600
	],
	"./CrownWheel/": [
		57600,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		57600
	],
	"./CrownWheel/index": [
		57600,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		57600
	],
	"./CrownWheel/index.tsx": [
		57600,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		57600
	],
	"./CrownWheelBlack": [
		77680,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		77680
	],
	"./CrownWheelBlack/": [
		77680,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		77680
	],
	"./CrownWheelBlack/index": [
		77680,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		77680
	],
	"./CrownWheelBlack/index.tsx": [
		77680,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		77680
	],
	"./CryptoExclusiveMay25": [
		79155,
		9,
		36320,
		79155
	],
	"./CryptoExclusiveMay25/": [
		79155,
		9,
		36320,
		79155
	],
	"./CryptoExclusiveMay25/index": [
		79155,
		9,
		36320,
		79155
	],
	"./CryptoExclusiveMay25/index.tsx": [
		79155,
		9,
		36320,
		79155
	],
	"./CryptoOfferMay2025": [
		95743,
		9,
		36320,
		95743
	],
	"./CryptoOfferMay2025/": [
		95743,
		9,
		36320,
		95743
	],
	"./CryptoOfferMay2025/index": [
		95743,
		9,
		36320,
		95743
	],
	"./CryptoOfferMay2025/index.tsx": [
		95743,
		9,
		36320,
		95743
	],
	"./DogTreasure": [
		66910,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		66910
	],
	"./DogTreasure/": [
		66910,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		66910
	],
	"./DogTreasure/index": [
		66910,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		66910
	],
	"./DogTreasure/index.tsx": [
		66910,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		66910
	],
	"./DogTreasureTerms": [
		51321,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		51321
	],
	"./DogTreasureTerms/": [
		51321,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		51321
	],
	"./DogTreasureTerms/index": [
		51321,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		51321
	],
	"./DogTreasureTerms/index.tsx": [
		51321,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		51321
	],
	"./EasterApril2025": [
		54711,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		54711
	],
	"./EasterApril2025/": [
		54711,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		54711
	],
	"./EasterApril2025/index": [
		54711,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		54711
	],
	"./EasterApril2025/index.tsx": [
		54711,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		54711
	],
	"./FiestaJune2025": [
		2218,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		2218
	],
	"./FiestaJune2025/": [
		2218,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		2218
	],
	"./FiestaJune2025/index": [
		2218,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		2218
	],
	"./FiestaJune2025/index.tsx": [
		2218,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		2218
	],
	"./GatesOfOlympus": [
		68867,
		9,
		44539,
		68867
	],
	"./GatesOfOlympus/": [
		68867,
		9,
		44539,
		68867
	],
	"./GatesOfOlympus/helpers": [
		83753,
		9,
		83753
	],
	"./GatesOfOlympus/helpers.ts": [
		83753,
		9,
		83753
	],
	"./GatesOfOlympus/index": [
		68867,
		9,
		44539,
		68867
	],
	"./GatesOfOlympus/index.tsx": [
		68867,
		9,
		44539,
		68867
	],
	"./JuicyCarMay2025": [
		58523,
		9,
		36320,
		58523
	],
	"./JuicyCarMay2025/": [
		58523,
		9,
		36320,
		58523
	],
	"./JuicyCarMay2025/index": [
		58523,
		9,
		36320,
		58523
	],
	"./JuicyCarMay2025/index.tsx": [
		58523,
		9,
		36320,
		58523
	],
	"./JuicyMay": [
		91796,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		91796
	],
	"./JuicyMay/": [
		91796,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		91796
	],
	"./JuicyMay/helpers": [
		11998,
		9,
		11998
	],
	"./JuicyMay/helpers.ts": [
		11998,
		9,
		11998
	],
	"./JuicyMay/index": [
		91796,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		91796
	],
	"./JuicyMay/index.tsx": [
		91796,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		91796
	],
	"./QuizBonusJune2025": [
		97111,
		9,
		54365,
		36320,
		89103,
		28132
	],
	"./QuizBonusJune2025/": [
		97111,
		9,
		54365,
		36320,
		89103,
		28132
	],
	"./QuizBonusJune2025/index": [
		97111,
		9,
		54365,
		36320,
		89103,
		28132
	],
	"./QuizBonusJune2025/index.tsx": [
		97111,
		9,
		54365,
		36320,
		89103,
		28132
	],
	"./RegDragonRewards": [
		94513,
		9,
		74332,
		35550,
		70290,
		94513
	],
	"./RegDragonRewards/": [
		94513,
		9,
		74332,
		35550,
		70290,
		94513
	],
	"./RegDragonRewards/index": [
		94513,
		9,
		74332,
		35550,
		70290,
		94513
	],
	"./RegDragonRewards/index.tsx": [
		94513,
		9,
		74332,
		35550,
		70290,
		94513
	],
	"./RegRewards": [
		34347,
		9,
		74332,
		35550,
		70290,
		34347
	],
	"./RegRewards/": [
		34347,
		9,
		74332,
		35550,
		70290,
		34347
	],
	"./RegRewards/index": [
		34347,
		9,
		74332,
		35550,
		70290,
		34347
	],
	"./RegRewards/index.tsx": [
		34347,
		9,
		74332,
		35550,
		70290,
		34347
	],
	"./SlotsCircle": [
		71534,
		9,
		36320,
		71534
	],
	"./SlotsCircle/": [
		71534,
		9,
		36320,
		71534
	],
	"./SlotsCircle/index": [
		71534,
		9,
		36320,
		71534
	],
	"./SlotsCircle/index.tsx": [
		71534,
		9,
		36320,
		71534
	],
	"./StarGoldCoast": [
		48301,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		48301
	],
	"./StarGoldCoast/": [
		48301,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		48301
	],
	"./StarGoldCoast/index": [
		48301,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		48301
	],
	"./StarGoldCoast/index.tsx": [
		48301,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		48301
	],
	"./SunOfEgypt": [
		39623,
		9,
		36320,
		39623
	],
	"./SunOfEgypt/": [
		39623,
		9,
		36320,
		39623
	],
	"./SunOfEgypt/index": [
		39623,
		9,
		36320,
		39623
	],
	"./SunOfEgypt/index.tsx": [
		39623,
		9,
		36320,
		39623
	],
	"./WelcomeApril2025": [
		83055,
		9,
		36320,
		83055
	],
	"./WelcomeApril2025/": [
		83055,
		9,
		36320,
		83055
	],
	"./WelcomeApril2025/index": [
		83055,
		9,
		36320,
		83055
	],
	"./WelcomeApril2025/index.tsx": [
		83055,
		9,
		36320,
		83055
	],
	"./WheelFortune": [
		38609,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		38609
	],
	"./WheelFortune/": [
		38609,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		38609
	],
	"./WheelFortune/index": [
		38609,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		38609
	],
	"./WheelFortune/index.tsx": [
		38609,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		38609
	],
	"./WinterJanuary": [
		33223,
		9,
		36320,
		33223
	],
	"./WinterJanuary/": [
		33223,
		9,
		36320,
		33223
	],
	"./WinterJanuary/index": [
		33223,
		9,
		36320,
		33223
	],
	"./WinterJanuary/index.tsx": [
		33223,
		9,
		36320,
		33223
	],
	"./WolfElvisSunBuffalo": [
		83087,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		83087
	],
	"./WolfElvisSunBuffalo/": [
		83087,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		83087
	],
	"./WolfElvisSunBuffalo/index": [
		83087,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		83087
	],
	"./WolfElvisSunBuffalo/index.tsx": [
		83087,
		9,
		74332,
		36320,
		35550,
		70290,
		26335,
		88844,
		83087
	],
	"./WolfWheel": [
		64260,
		9,
		74332,
		36320,
		35550,
		70290,
		64260
	],
	"./WolfWheel/": [
		64260,
		9,
		74332,
		36320,
		35550,
		70290,
		64260
	],
	"./WolfWheel/index": [
		64260,
		9,
		74332,
		36320,
		35550,
		70290,
		64260
	],
	"./WolfWheel/index.tsx": [
		64260,
		9,
		74332,
		36320,
		35550,
		70290,
		64260
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 63687;
module.exports = webpackAsyncContext;